import { TableHeader } from 'components/Table'
import cx from 'classnames'
import styles from './ServiceTableHeader.sass'
import React from 'react'
import { observer } from 'mobx-react'

interface ServiceTableHeaderProps {
  children: string
  align: 'right' | 'left'
}

export default observer(function ServiceTableHeader({
  children,
  align,
}: ServiceTableHeaderProps) {
  return (
    <TableHeader>
      <div className={cx(styles.tableHeader, styles[align])}>{children}</div>
    </TableHeader>
  )
})
